import _ from 'lodash';
import React from 'react';
import styles from './css/SuggestedEntries.styl';
import classNames from 'classnames';
import {bindMethods} from '../../../../shared/utilities/componentHelpers';
import {Collapse} from '../../../../shared/library';
import {suggestedEntries} from '../../../../../data/suggestedEntries.json';

/**
 * suggested condolence entries
 * @class SuggestedEntries
 */
export default class SuggestedEntries extends React.Component {
  static propTypes = {
    setSuggestedEntry: React.PropTypes.func,
  };

  constructor() {
    super();

    this.state = {isExpanded: false};

    this.entries = _.map(suggestedEntries, this.createEntry);

    bindMethods(this, ['handleToggleClick']);
  }

  /**
   * Builds out an object with the active flag, display and full text
   * @param  {string} entry the full suggested entry
   * @return {object} the entry object
   */
  createEntry(entry) {
    const displayOptions = {
      separator: ' ',
      length: 35,
    };

    return {
      isActive: false,
      displayText: _.truncate(entry, displayOptions),
      fullText: entry,
    };
  }

  /**
   * Sets the style flag for the active suggested entry
   * @param  {array}     entries     the array of suggested entries
   * @param  {number}    activeIndex the location of the current active entry
   * @return {undefined} returns nothing
   */
  setActiveStyle(entries, activeIndex) {
    _.forEach(entries, (entry, index) => {
      if (index === activeIndex) {
        entry.isActive = true;
      } else {
        entry.isActive = false;
      }
    });
  }

  /**
   * Sets the static and dynamic styles for each of the suggested entries
   * @param  {boolean}   isActive is a particular entry currently active?
   * @return {string}    the current classes for each entry
   */
  setEntryStyles(isActive) {
    const conditionalClasses = {};

    conditionalClasses[styles.active] = isActive;

    return classNames(styles.entry, conditionalClasses);
  }

  /**
   * Seeds the click handler with the full entry text and the current index
   * @param  {array}     entries the suggested entry array
   * @param  {number}    index   the location of the current selected entry
   * @return {function}  Seeded click handler
   */
  handleEntryClick(entries, index) {
    return () => {
      this.setActiveStyle(entries, index);
      this.props.setSuggestedEntry(entries[index].fullText);
    };
  }

  /**
   * Expand or collapse the suggested entries section
   * @return {undefined} returns nothing
   */
  handleToggleClick() {
    this.setState(prevState => ({isExpanded: !prevState.isExpanded}));
  }

  /**
   * Sets active flags to false and closes the suggested entries module
   * @return {undefined}  returns nothing
   */
  resetEntries() {
    if (this.state.isExpanded) {
      this.setState({isExpanded: false});
    }

    _.forEach(this.entries, entry => {
      entry.isActive = false;
    });
  }

  render() {
    const {isExpanded} = this.state;
    const toggleText = isExpanded
      ? 'Hide Suggestions ^'
      : 'Not sure what to say?';

    return _.isFunction(this.props.setSuggestedEntry) ? (
      <div className={styles.SuggestedEntries}>
        <p className={styles.toggleEntries} onClick={this.handleToggleClick}>
          {toggleText}
        </p>
        <Collapse in={isExpanded}>
          <div aria-hidden={!isExpanded}>
            {this.entries.map((entry, index) => (
              <div
                alt={entry.fullText}
                className={this.setEntryStyles(entry.isActive)}
                key={index}
                onClick={this.handleEntryClick(this.entries, index)}
                title={entry.fullText}
              >
                <p>{entry.displayText}</p>
              </div>
            ))}
            <div className={styles.clearFix} />
          </div>
        </Collapse>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/GuestBook/SuggestedEntries.js